<template>
  <div class="box">
    <!-- 顶部背景图 -->
    <div class="top">
      <div class="t-t1">招聘职位</div>
      <div class="t-t2box">
        <div class="t-t2">选择机遇 选择未来</div>
      </div>
    </div>

    <div class="box1">
      <div class="item">
        <div class="title">
          <img src="@/image/contact/juxin.png" alt="" />
          <div class="tit1">客户资讯师</div>
          <div class="price">7-8k</div>
        </div>

        <!-- 内容 -->
        <div class="textbox">
          <div class="t1">岗位描述</div>
          <div class="t2">1、协助项目工作人员完成项目前、中、后期所需的文案写作工作。</div>
          <div class="t2">2、参与项目前期开发，负责维护客户关系、整理咨询信息，进行整合处处理。</div>
          <div class="t2">3、完成项目咨询 (研究) 报告 撰写工作</div>
        </div>

        <div class="textbox">
          <div class="t1">职位要求</div>
          <div class="t2">1、硕士（含）以上学历。</div>
          <div class="t2">2、经济类、工程类、金融类相关专业。</div>
          <div class="t2">3、英语四级及以上水平，具备英语听、说、读、写熟练水平。</div>
          <div class="t2">4、理论功底扎实，写作能力较强，具备一定跨学科或交叉研究学习能力。</div>
          <div class="t2">5、有过产业规划咨询、投融资咨询、工程咨询等相关企业工作经历优先。</div>
          <div class="t2">6、在知名文学刊、报发表过研究成果优先</div>
          <div class="t2">7、有良好的的敬业精神、职业带的道德操守、有责任心、学习能力强、可塑性强。</div>
        </div>

        <div class="textbox">
          <div class="t1">福利待遇</div>
          <div class="t2">底薪 +提成+ 课酬 + 五险一金+补助</div>
          <div class="t2">带薪培训学习、带薪免费旅游、生日及节假日福利费</div>
        </div>

        <!-- 底部 -->
        <div class="bootm">
          <div class="b1">如果您的能力符合我们的岗位要求，请将简历投递至：</div>
          <div class="b2">Ditingzixun@163.com</div>
        </div>
      </div>

      <div class="item">
        <div class="title">
          <img src="@/image/contact/juxin.png" alt="" />
          <div class="tit1">客户资讯师</div>
          <div class="price">7-8k</div>
        </div>

        <!-- 内容 -->
        <div class="textbox">
          <div class="t1">岗位描述</div>
          <div class="t2">1、协助项目工作人员完成项目前、中、后期所需的文案写作工作。</div>
          <div class="t2">2、参与项目前期开发，负责维护客户关系、整理咨询信息，进行整合处处理。</div>
          <div class="t2">3、完成项目咨询 (研究) 报告 撰写工作</div>
        </div>

        <div class="textbox">
          <div class="t1">职位要求</div>
          <div class="t2">1、硕士（含）以上学历。</div>
          <div class="t2">2、经济类、工程类、金融类相关专业。</div>
          <div class="t2">3、英语四级及以上水平，具备英语听、说、读、写熟练水平。</div>
          <div class="t2">4、理论功底扎实，写作能力较强，具备一定跨学科或交叉研究学习能力。</div>
          <div class="t2">5、有过产业规划咨询、投融资咨询、工程咨询等相关企业工作经历优先。</div>
          <div class="t2">6、在知名文学刊、报发表过研究成果优先</div>
          <div class="t2">7、有良好的的敬业精神、职业带的道德操守、有责任心、学习能力强、可塑性强。</div>
        </div>

        <div class="textbox">
          <div class="t1">福利待遇</div>
          <div class="t2">底薪 +提成+ 课酬 + 五险一金+补助</div>
          <div class="t2">带薪培训学习、带薪免费旅游、生日及节假日福利费</div>
        </div>

        <!-- 底部 -->
        <div class="bootm">
          <div class="b1">如果您的能力符合我们的岗位要求，请将简历投递至：</div>
          <div class="b2">Ditingzixun@163.com</div>
        </div>
      </div>

      <div class="item">
        <div class="title">
          <img src="@/image/contact/juxin.png" alt="" />
          <div class="tit1">客户资讯师</div>
          <div class="price">7-8k</div>
        </div>

        <!-- 内容 -->
        <div class="textbox">
          <div class="t1">岗位描述</div>
          <div class="t2">1、协助项目工作人员完成项目前、中、后期所需的文案写作工作。</div>
          <div class="t2">2、参与项目前期开发，负责维护客户关系、整理咨询信息，进行整合处处理。</div>
          <div class="t2">3、完成项目咨询 (研究) 报告 撰写工作</div>
        </div>

        <div class="textbox">
          <div class="t1">职位要求</div>
          <div class="t2">1、硕士（含）以上学历。</div>
          <div class="t2">2、经济类、工程类、金融类相关专业。</div>
          <div class="t2">3、英语四级及以上水平，具备英语听、说、读、写熟练水平。</div>
          <div class="t2">4、理论功底扎实，写作能力较强，具备一定跨学科或交叉研究学习能力。</div>
          <div class="t2">5、有过产业规划咨询、投融资咨询、工程咨询等相关企业工作经历优先。</div>
          <div class="t2">6、在知名文学刊、报发表过研究成果优先</div>
          <div class="t2">7、有良好的的敬业精神、职业带的道德操守、有责任心、学习能力强、可塑性强。</div>
        </div>

        <div class="textbox">
          <div class="t1">福利待遇</div>
          <div class="t2">底薪 +提成+ 课酬 + 五险一金+补助</div>
          <div class="t2">带薪培训学习、带薪免费旅游、生日及节假日福利费</div>
        </div>

        <!-- 底部 -->
        <div class="bootm">
          <div class="b1">如果您的能力符合我们的岗位要求，请将简历投递至：</div>
          <div class="b2">Ditingzixun@163.com</div>
        </div>
      </div>

      <div class="item">
        <div class="title">
          <img src="@/image/contact/juxin.png" alt="" />
          <div class="tit1">客户资讯师</div>
          <div class="price">7-8k</div>
        </div>

        <!-- 内容 -->
        <div class="textbox">
          <div class="t1">岗位描述</div>
          <div class="t2">1、协助项目工作人员完成项目前、中、后期所需的文案写作工作。</div>
          <div class="t2">2、参与项目前期开发，负责维护客户关系、整理咨询信息，进行整合处处理。</div>
          <div class="t2">3、完成项目咨询 (研究) 报告 撰写工作</div>
        </div>

        <div class="textbox">
          <div class="t1">职位要求</div>
          <div class="t2">1、硕士（含）以上学历。</div>
          <div class="t2">2、经济类、工程类、金融类相关专业。</div>
          <div class="t2">3、英语四级及以上水平，具备英语听、说、读、写熟练水平。</div>
          <div class="t2">4、理论功底扎实，写作能力较强，具备一定跨学科或交叉研究学习能力。</div>
          <div class="t2">5、有过产业规划咨询、投融资咨询、工程咨询等相关企业工作经历优先。</div>
          <div class="t2">6、在知名文学刊、报发表过研究成果优先</div>
          <div class="t2">7、有良好的的敬业精神、职业带的道德操守、有责任心、学习能力强、可塑性强。</div>
        </div>

        <div class="textbox">
          <div class="t1">福利待遇</div>
          <div class="t2">底薪 +提成+ 课酬 + 五险一金+补助</div>
          <div class="t2">带薪培训学习、带薪免费旅游、生日及节假日福利费</div>
        </div>

        <!-- 底部 -->
        <div class="bootm">
          <div class="b1">如果您的能力符合我们的岗位要求，请将简历投递至：</div>
          <div class="b2">Ditingzixun@163.com</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AaawwxxIndex',

  data() {
    return {}
  },

  mounted() {},

  methods: {
    goNewX() {
      this.$router.push('/newsx')
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
}

// 顶部
.top {
  z-index: -1;
  position: relative;
  height: 480px;
  background-image: url('@/image/contact/banner@2x.png');
  background-repeat: no-repeat;

  .t-t1 {
    font-size: 60px;
    color: #000;
    position: absolute;
    z-index: 100;
    top: 28%;
    left: 20%;
  }

  .t-t2box {
    padding-left: 5px;
    color: #666666;
    z-index: 100;
    position: absolute;
    top: 48%;
    left: 20%;
    .t-t2 {
      font-size: 24px;
      margin: 10px 0;
    }
  }
}

.box1 {
  width: 72%;
  display: flex;
  margin: 60px auto;
  padding-left: 180px;
  flex-wrap: wrap;

  .item {
    width: 590px;
    height: 660px;
    // border: 1px solid;
    margin-right: 25px;
    margin-bottom: 25px;
    box-shadow: -5px -5px 15px #efefef, 10px 0px 10px #efefef, 0px 10px 10px #efefef;
    //标题
    .title {
      margin-top: 30px;
      position: relative;
      height: 48px;
      line-height: 48px;
      text-align: center;
      // overflow: hidden;

      img {
        position: absolute;
        left: 0;
        top: 0;
        width: 60%;
        height: 100%;
        z-index: -100;
      }

      .tit1 {
        position: absolute;
        left: 25px;
        font-size: 22px;
      }
      .price {
        font-size: 22px;
        position: absolute;
        right: 10%;
        color: #4581fb;
      }
    }
    .title::after {
      display: block;
      content: ' ';
      background-color: #4581fb;
      position: absolute;
      left: 0;
      width: 4px;
      height: 48px;
    }
    //标题 end ------------------

    // 中间内容
    .textbox {
      margin: 20px 0 25px 25px;
      .t1 {
        color: #333333;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 15px;
      }
      .t2 {
        margin-bottom: 4px;
        color: #333333;
        font-size: 14px;
        letter-spacing: 1px;
      }
    }

    // 中间内容 end---------------

    //底部
    .bootm {
      margin: 40px 50px 0 30px;
      height: 100px;
      border-top: 2px solid #fafafa;
      font-size: 16px;

      .b1 {
        margin-top: 20px;
        font-weight: 600;
      }
      .b2 {
        font-weight: 600;
        margin-top: 8px;
      }
    }

    //底部 end------------
  }

  //阴影
  .item:nth-child(2) {
    box-shadow: 0px 10px 15px #efefef, 0px -3px 5px #efefef, 3px 0px 5px #efefef, -10px 0px 20px #efefef;
  }
  .item:nth-child(4) {
    box-shadow: 0px 1px 1px #efefef, 0px -5px 20px #efefef, 3px 0px 5px #efefef, -10px 0px 20px #efefef;
  }
  .item:nth-child(1) {
    box-shadow: 0px 10px 15px #efefef, 0px -3px 5px #efefef, -3px 0px 5px #efefef, 10px 0px 20px #efefef;
  }
  .item:nth-child(3) {
    box-shadow: 0px 1px 1px #efefef, 0px -5px 20px #efefef, -3px 0px 5px #efefef, 10px 0px 20px #efefef;
  }
}
</style>
